<template>
	<v-speed-dial
		v-if="!$vuetify.breakpoint.xsOnly"
		v-model="fab"
		absolute
		:open-on-hover="false"
		:direction="$vuetify.breakpoint.xsOnly ? 'top' : 'right'"
		style="left: 15px; z-index: 1"
		:transition="
			$vuetify.breakpoint.xsOnly
				? 'slide-y-reverse-transition'
				: 'slide-x-transition'
		"
	>
		<template v-slot:activator>
			<v-btn v-model="fab" icon>
				<v-icon large v-if="fab"> mdi-close </v-icon>
				<v-icon v-else large> mdi-dots-vertical </v-icon>
			</v-btn>
		</template>
		<v-btn
			v-if="ckeckGroupPermission([])"
			fab
			dark
			color="indigo"
			@click="newTtForm"
		>
			<v-icon large>mdi-account-plus</v-icon>
		</v-btn>
		<v-btn
			v-if="ckeckGroupPermission([])"
			fab
			dark
			color="orange"
			@click="queryTt"
		>
			<v-icon large>mdi-database-search</v-icon>
		</v-btn>
		<!-- <v-btn
			v-if="ckeckGroupPermission([GROUPS.MASMOVIL])"
			fab
			dark
			color="pink"
			@click="openCoverage"
		>
			<v-icon large>mdi-wifi-sync</v-icon>
		</v-btn> -->
		<!-- <v-btn
			v-if="
				ckeckGroupPermission([GROUPS.MASMOVIL]) && !isComercialCobOrRec
			"
			fab
			dark
			color="red"
			@click="openResources"
		>
			<v-icon large>mdi-package-down</v-icon>
		</v-btn> -->
		<v-btn
			v-if="$store.getters['login/hasManagerPermission'] && !tableLoading"
			color="green"
			fab
			dark
			@click="openSpreadsheetDialog()"
		>
			<v-icon large> mdi-microsoft-excel </v-icon>
		</v-btn>
		<div class="d-flex" v-if="ckeckGroupPermission([GROUPS.AVATEL])">
			<v-btn color="purple" fab dark @click="openCoverageAvatel()">
				<v-icon large> mdi-fingerprint</v-icon>
			</v-btn>
			<v-btn color="primary" fab dark @click="openSpreadsheetForm()">
				<v-icon large> mdi-antenna </v-icon>
			</v-btn>
		</div>
	</v-speed-dial>
	<div v-else class="px-4 mb-12 pb-4" style="position: absolute; bottom: 15px; right: 15px; z-index: 1">
		<v-btn
			v-if="ckeckGroupPermission([])"
			fab
			dark
			color="indigo"
			@click="newTtForm"
			class="mb-2"
		>
			<v-icon large>mdi-account-plus</v-icon>
		</v-btn>
		<v-btn
			v-if="ckeckGroupPermission([])"
			fab
			dark
			color="orange"
			@click="queryTt"
			class="mb-2"
		>
			<v-icon large>mdi-database-search</v-icon>
		</v-btn>
		<!-- <v-btn
			v-if="ckeckGroupPermission([GROUPS.MASMOVIL])"
			fab
			dark
			color="pink"
			@click="openCoverage"
			class="mb-2"
		>
			<v-icon large>mdi-wifi-sync</v-icon>
		</v-btn> -->
		<!-- <v-btn
			v-if="
				ckeckGroupPermission([GROUPS.MASMOVIL]) && !isComercialCobOrRec
			"
			fab
			dark
			color="red"
			@click="openResources"
			class="mb-2"
		>
			<v-icon large>mdi-package-down</v-icon>
		</v-btn> -->
		<v-btn
			v-if="$store.getters['login/hasManagerPermission'] && !tableLoading"
			color="green"
			fab
			dark
			@click="openSpreadsheetDialog()"
			class="mb-2"
		>
			<v-icon large> mdi-microsoft-excel </v-icon>
		</v-btn>
		<v-btn color="purple" fab dark @click="openCoverageAvatel()" v-if="ckeckGroupPermission([GROUPS.AVATEL])" class="mb-2">
			<v-icon large> mdi-fingerprint</v-icon>
		</v-btn>
		<v-btn color="primary" fab dark @click="openSpreadsheetForm()" v-if="ckeckGroupPermission([GROUPS.AVATEL])" class="mb-2">
			<v-icon large> mdi-antenna </v-icon>
		</v-btn>
	</div>
</template>
<script>
import { mapState, mapGetters } from 'vuex';

export default {
	name: 'Dial',
	data: () => ({
		fab: false,
	}),
	methods: {
		openSpreadsheetForm() {
			this.$store.commit('util/isOpenDownloadTemplateAndUpload', true);
		},
		newTtForm() {
			this.$store.dispatch('teletrabajo/addTtForm');
		},
		queryTt() {
			this.$store.dispatch('teletrabajo/openTtQueryDialog');
		},
		openCoverage() {
			this.$store.commit('coverage/isOpenCoverage', true);
		},
		openCoverageAvatel() {
			this.$store.commit('coverageAvatel/isOpenCoverageAvatel', true);
		},
		openResources() {
			this.$store.commit('resources/isOpenResources', true);
		},
		openSpreadsheetDialog() {
			this.$store.commit('teletrabajo/IsOpenSpreadsheetDialog', true);
			// this.$store.dispatch('teletrabajo/exportDB');
		},
	},
	computed: {
		...mapState('general', {
			GROUPS: (state) => state.GROUPS,
		}),
		...mapState('login', {
			groups: (state) => state.groups,
		}),
		...mapState({
			tableLoading: (state) => state.teletrabajo.IsTableLoading,
		}),
		...mapGetters('login', {
			isComercialCobOrRec: 'isComercialCobOrRec',
			ckeckGroupPermission: 'ckeckGroupPermission',
			isComercialColaborador: 'isComercialColaborador',
		}),
	},
};
</script>